export default __webpack_public_path__ + "static/media/icon-ic-distance.6d5d69d0.svg";